import React, { useState, useRef } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getDataFromAPI } from "../../../HandleAPICalls/actions";
import { toastr } from "react-redux-toastr";
import CategoryCreateComponent from "./component";

const CategoryCreateContainer = (props) => {
  const navigate = useNavigate();
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    description: "",
    active: true,
  });

  const [imageFile, setImageFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isImageUploading, setIsImageUploading] = useState(false);
  const [imagePath, setImagePath] = useState("");
  const [createdItemName, setCreatedItemName] = useState("");
  const [createdItemId, setCreatedItemId] = useState("");

  const imageInputRef = useRef(null);

  // Form validation - only name is required
  const isFormValid = formData.name.trim() !== "";

  // Machine Image Upload API
  const uploadImageToS3 = async (file) => {
    if (!file) return null;
    
    const formDataUpload = new FormData();
    formDataUpload.append("file", file);
    
    return new Promise((resolve, reject) => {
      props.getDataFromAPI(
        "/partner/api/v2/s3upload/machine-image",
        "POST",
        formDataUpload,
        (response) => {
          const uploadedPath = response?.image_path || response?.data?.image_path || response?.path || response?.url;
          
          if (!uploadedPath) {
            reject(new Error("No image path received from upload API"));
            return;
          }
          
          toastr.success("Success", "Image uploaded successfully");
          resolve(uploadedPath);
        },
        (err) => {
          toastr.error("Failed", "Unable to upload image");
          reject(err);
        }
      );
    });
  };

  // Handle Image Selection
  const handleImageFileSelect = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    
    if (!file.type.match('image.*')) {
      toastr.error("Error", "Please upload an image file");
      return;
    }
    
    if (file.size > 5 * 1024 * 1024) {
      toastr.error("Error", "Image size should be less than 5MB");
      return;
    }
    
    setIsImageUploading(true);
    setImageFile(file);
    
    const reader = new FileReader();
    reader.onloadend = () => setImagePreview(reader.result);
    reader.readAsDataURL(file);
    
    try {
      const uploadedPath = await uploadImageToS3(file);
      setImagePath(uploadedPath);
      console.log("Image uploaded to:", uploadedPath);
    } catch (error) {
      setImagePreview(null);
      setImageFile(null);
    } finally {
      setIsImageUploading(false);
    }
  };

  const handleClearImage = () => {
    setImageFile(null);
    setImagePreview(null);
    setImagePath("");
    if (imageInputRef.current) imageInputRef.current.value = "";
  };

  const handleBackClick = () => navigate(-1);

  const handleSave = async () => {
    if (!isFormValid) {
      toastr.warning("Incomplete Form", "Please enter category name");
      return;
    }
    
    setIsSubmitting(true);

    // Prepare payload for create category API - only name, description, image
    const payload = {
      name: formData.name,
      description: formData.description || "",
      image: imagePath || "",
    };

    console.log("Create Category Payload:", payload);

    props.getDataFromAPI(
      `/partner/api/v1/product-categories`,
      "POST",
      payload,
      (response) => {
        setIsSubmitting(false);
        const newId = response?.id || response?.data?.id || "N/A";
        const newName = response?.name || response?.data?.name || formData.name;
        setCreatedItemName(newName);
        setCreatedItemId(newId);
        setShowSuccessPopup(true);
        toastr.success("Success", "Category created successfully!");
      },
      (error) => {
        setIsSubmitting(false);
        toastr.error("Error", error?.message || "Failed to create category");
      }
    );
  };

  const handleCloseSuccessPopup = () => {
    setShowSuccessPopup(false);
    navigate(-1);
  };

  return (
    <CategoryCreateComponent
      formData={formData}
      setFormData={setFormData}
      iconPreview={imagePreview}
      bgPreview={""}
      useTransparentBg={false}
      variantIds={[]}
      variantDetails={{}}
      inputValue={""}
      setInputValue={() => {}}
      iconInputRef={imageInputRef}
      backgroundInputRef={null}
      isFormValid={isFormValid}
      isSubmitting={isSubmitting}
      isIconUploading={isImageUploading}
      isBgUploading={false}
      showSuccessPopup={showSuccessPopup}
      setShowSuccessPopup={handleCloseSuccessPopup}
      handleToggleTransparent={() => {}}
      handleAddId={() => {}}
      removeId={() => {}}
      handleClearAllVariants={() => {}}
      handleBackClick={handleBackClick}
      handleSave={handleSave}
      handleIconFileSelect={handleImageFileSelect}
      handleBgFileSelect={() => {}}
      handleClearIcon={handleClearImage}
      handleClearBg={() => {}}
      iconPath={imagePath}
      bgPath={""}
      createdItemName={createdItemName}
      createdItemId={createdItemId}
      isVerifying={false}
    />
  );
};

function mapStateToProps(state) {
  return { props: state };
}

export default connect(mapStateToProps, { getDataFromAPI })(CategoryCreateContainer);